import { newsBase } from '../ipConfig'

//  获取楼层所有文物
export const getMaprelicListUrl = `${newsBase}/museum_hn/api/map/maprelic/list.html`;
//  获取文物介绍
export const getMaprelicInfoUrl = `${newsBase}/museum_hn/api/map/maprelic/getInfo.html`;